/* eslint-disable react/prop-types */
import React from 'react';
import { Icon, IconTile } from 'components/v3';

// Generic detail-view modal: dimmed overlay + scrollable content card with a
// header (orange icon tile + title + close). `icon` is a v3 Icon name. Pass
// `fullscreen` for the radar view. Overlay/content styling is scoped in
// styles.js. Body is provided as `children`.
const Modal = ({ open, onClose, icon, title, fullscreen, children }) => (
  <div
    className={`modal-overlay${open ? ' active' : ''}${
      fullscreen ? ' fullscreen' : ''
    }`}
    role="presentation"
    onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}
  >
    {open ? (
      <div className="modal-content" role="dialog" aria-modal="true">
        <div className="modal-header">
          <div className="modal-title">
            {icon ? <IconTile icon={icon} size={42} iconSize={22} /> : null}
            <span className="modal-title-text">{title}</span>
          </div>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon name="x" size={18} strokeWidth={2.5} />
          </button>
        </div>
        {children}
      </div>
    ) : null}
  </div>
);

export default Modal;
